<div class="manifest-search-column">
  <a [routerLink]="[routerLink, searchableValue]">{{ searchableValue }}</a>
</div>
